import { environment } from '../../../../environments/environment'
import { type CartoClient } from './carto.helper'
import { type PoisFilters } from './pois.service'

export interface TrafficQuantilesRow {
  q1: number
  q2: number
  q3: number
  q4: number
  q5: number
  q6: number
}

export async function fetchTrafficQuantiles(
  cartoClient: CartoClient,
  filters: PoisFilters,
  signal?: AbortSignal,
): Promise<TrafficQuantilesRow | null> {
  const { delivery_id, delivery_start_date, filter_combined } = filters

  const response = await cartoClient.query<TrafficQuantilesRow>({
    source: {
      source: `${environment.CARTO_SOURCE_PREFIX}_quantiles`,
      queryParameters: {
        delivery_id,
        delivery_start_date,
        filter_combined,
      },
    },
    params: {
      column: ['q1', 'q2', 'q3', 'q4', 'q5', 'q6'],
    },
    signal,
  })

  return response?.rows?.[0] ?? null
}
